import React from 'react';
import PropTypes from 'prop-types';
import Widgets from '@medscape-promo/medscapetv/main/widgets';

function EpisodeContent(props) {
    const { widgets, episodeLabel, episodeTitle, publishDate } = props;
    // Render PublishDate twice for UX Responsive Design
    return (
        <div className="episode-content">
            <div className="top-row-container">
                <div className="episode-info">
                    <div className="info-container">
                        <div className="episode-label"><span dangerouslySetInnerHTML={{__html: episodeLabel} }></span></div>
                        { publishDate == null ? null : <PublishDate {...publishDate } />}
                    </div>
                </div>
                <div className="widgets">
                    <Widgets {...widgets} />
                </div>
            </div>
            <h1 className="episode-title" dangerouslySetInnerHTML={{__html: episodeTitle} }></h1>
            <div className="publish-date-container">
                { publishDate == null ? null : <PublishDate {...publishDate } />}
            </div>
        </div>
    )
}
EpisodeContent.propTypes = {
    widgets: PropTypes.object,
    episodeLabel: PropTypes.string,
    episodeTitle: PropTypes.string,
    publishDate: PropTypes.object
}
EpisodeContent.defaultProps = {
    widgets: {},
    episodeLabel: "",
    episodeTitle: ""
}
function getDateString(date = null) {
    let dateParts = date.split("-");
    let day = dateParts[2];
    let month = dateParts[1];
    let year = dateParts[0];

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${months[parseInt(month)-1]} ${day}, ${year}`;
}

function PublishDate(props) {
    const { text, date, enable } = props;
    if (enable === false || text == null || text.trim().length == 0) {
        return null;
    } else {
        let dateString = getDateString(date);
        let publishDate = text.replace('[date-string]', dateString);
        return (
            <span className="publish-date">{publishDate}</span>
        )
    }
}
PublishDate.propTypes = {
    text: PropTypes.string,
    date: PropTypes.string,
    enable: PropTypes.bool
}
PublishDate.defaultProps = {
    text: "",
    date: "",
    enable: false
}
export default EpisodeContent;